import React from "react";
import {ChevronDown} from "lucide-react";
import {cn} from "../../utils/cn";

/**
 * Native <select> styled to match the Input. Use this for ≤8 options.
 * For larger lists, comboboxes, or async-loaded data, use the Radix
 * Combobox primitive (planned).
 */
const Select = React.forwardRef(function Select(
  {className, hasError = false, children, ...props},
  ref
) {
  return (
    <div className="relative">
      <select
        ref={ref}
        className={cn(
          "block w-full h-9 pl-3 pr-9 text-base rounded-md appearance-none",
          "bg-white border border-ink-200 shadow-inset",
          "text-ink-900",
          "transition-colors duration-fast cursor-pointer",
          "hover:border-ink-300",
          "focus:border-brand-500 focus:outline-none focus:ring focus:ring-offset-0",
          "disabled:bg-ink-50 disabled:text-ink-400 disabled:cursor-not-allowed",
          hasError && "border-danger-500 focus:border-danger-500",
          className
        )}
        {...props}
      >
        {children}
      </select>
      <ChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 h-4 w-4 text-ink-400 pointer-events-none" aria-hidden="true" />
    </div>
  );
});

export default Select;
